import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
  export default new Vuex.Store({
    state: {
      // 要回显的数据
      imgUrl:'http://www.shenhaoyaoye.com/webpic/',
      logoImg:'http://www.shenhaoyaoye.com/',
      companyID:5,//神豪5
      lunboList:[],
      gongsijianjie:'',
      gongsipic:'',
      productList:[],
      companypic:{},
      companyName:'深豪药业',
      quanming:'河北深豪药业有限公司',
      appName:'深豪药业',
      logo:'',
      footerInfo:{},
      addresscoordinate:''
    },
    getters: {
    },
    mutations: {
        CHANGE_ADDRESSCOORDINATE: (state, addresscoordinate) => state.addresscoordinate = addresscoordinate,
      CHANGE_LUNboList: (state, lunbolist) => state.lunboList = lunbolist,
      CHANGE_LOGO: (state, logo) => state.logo =logo,
      
      CHANGE_GONGSIJIANJIE: (state, JIANJIE) => state.gongsijianjie = JIANJIE,
      CHANGE_GONGSIPIC: (state, gongsipic) => state.gongsipic = gongsipic,
      CHANGE_PRODUCTLIST: (state, productList) => state.productList = productList,
      CHANGE_COMPANYPIC: (state, companypic) => state.companypic = companypic,
      CHANGE_footerInfo: (state, footerInfo) => state.footerInfo = footerInfo,
      
    },
    actions: {
    },
    modules: {
    }
  })




// WEBPACK FOOTER //
// ./src/store/index.js